import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
type ImageRevealProps = {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
  parallax?: number;
};
export function ImageReveal({
  src,
  alt,
  className = '',
  imgClassName = '',
  parallax = 0
}: ImageRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-parallax, parallax]);
  return <div ref={ref} className={`relative overflow-hidden ${className}`} data-id="element-92" data-mp="205gd92jvvr9z">
      <motion.div className="h-full w-full" style={parallax ? {
      y
    } : undefined} initial={{
      scale: 1.12,
      opacity: 0
    }} whileInView={{
      scale: 1,
      opacity: 1
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 1.4,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-93" data-mp="1vbc3kbj8h557">
        <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover ${imgClassName}`} data-id="element-94" data-mp="2j0y2cxvp1ico" />
      </motion.div>
    </div>;
}